import { IconButton, Tooltip } from '@mui/material';
import { PlayArrow, Pause } from '@mui/icons-material';

interface Props {
  /** The row's own status, not its effective one — you can only change what you own. */
  status?: string;
  noun: string;
  onToggle: (status: 'ACTIVE' | 'PAUSED') => void;
}

/**
 * The icon is the action, not the state: a running campaign offers a pause. Deliberately
 * dumb — the dialogs live at page level, because scrolling unmounts a grid row and would
 * take an open confirmation with it.
 */
export default function AdStatusToggle({ status, noun, onToggle }: Props) {
  if (status !== 'ACTIVE' && status !== 'PAUSED') return null;
  const running = status === 'ACTIVE';

  return (
    <Tooltip title={running ? `Pause this ${noun}` : `Resume this ${noun}`}>
      <IconButton
        size="small"
        aria-label={running ? `Pause this ${noun}` : `Resume this ${noun}`}
        onClick={(e) => { e.stopPropagation(); onToggle(running ? 'PAUSED' : 'ACTIVE'); }}
      >
        {running ? <Pause fontSize="small" /> : <PlayArrow fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
